const merkuriusQuiz = [ 
    {
    question: "Merkurius adalah planet ke berapa dari Matahari?",
    options: ["1", "2", "3", "4"],
    answer: 0,
  },
  {
    question: "Merkurius dikenal sebagai planet yang?",
    options: [
      "Paling besar",
      "Paling panas",
      "Paling dekat dengan Matahari",
      "Paling banyak bulan",
    ],
    answer: 2,
  },
  {
    question: "Apakah Merkurius memiliki atmosfer tebal?",
    options: [
      "Ya, sangat tebal",
      "Ya, tipis",
      "Tidak, hampir tidak ada",
      "Sama seperti Bumi",
    ],
    answer: 2,
  },
  {
    question: "Mengapa suhu di Merkurius sangat ekstrem?",
    options: [
      "Karena dekat dengan Matahari dan hampir tidak punya atmosfer",
      "Karena terlalu jauh dari Matahari",
      "Karena memiliki banyak laut",
      "Karena selalu berputar cepat",
    ],
    answer: 0,
  },
  {
    question: "Berapa jumlah bulan yang dimiliki Merkurius?",
    options: ["0", "1", "2", "4"],
    answer: 0,
  },
  {
    question: "Permukaan Merkurius mirip dengan?",
    options: [
      "Mars",
      "Venus",
      "Bulan",
      "Bumi",
    ],
    answer: 2,
  },
  {
    question: "Waktu rotasi Merkurius (1 hari di Merkurius) adalah?",
    options: [
      "Sekitar 24 jam",
      "Sekitar 59 hari Bumi",
      "Sekitar 365 hari",
      "Sekitar 7 hari",
    ],
    answer: 1,
  },
  {
    question: "Waktu revolusi Merkurius mengelilingi Matahari adalah?",
    options: [
      "88 hari Bumi",
      "180 hari Bumi",
      "365 hari Bumi",
      "687 hari Bumi",
    ],
    answer: 0,
  },
  {
    question: "Apakah Merkurius memiliki cincin?",
    options: [
      "Ya",
      "Tidak",
      "Hanya terlihat dari Bumi",
      "Kadang-kadang",
    ],
    answer: 1,
  },
  {
    question: "Mengapa Merkurius sulit diamati dari Bumi?",
    options: [
      "Karena terlalu kecil",
      "Karena terlalu gelap",
      "Karena selalu dekat dengan Matahari",
      "Karena tertutup awan",
    ],
    answer: 2,
  },
]

export default merkuriusQuiz;